
    import {Component, Vue} from 'vue-property-decorator'
    import {Getter} from "vuex-class";
    import {getOperateLog, LogListApi} from "@/api/order";
    Component.registerHooks(['beforeRouteEnter']);

    @Component({
      name: 'Log'
    })
    export default class Log extends Vue {
        @Getter companyId!: string

        params = {
            isReturn: true, // 是否是退货单 Boolean
            companyId: "",
            currRouteId: '',
            orderId: "",
            isValid: "Y"
        }
        logList: LogListApi[] = []

        beforeRouteEnter(to, from, next) {
            if (to.query.isReturn === '1') {
                to.meta.title = '退单日志'
            } else{
                to.meta.title = '订单日志'
            }
            next();
        }

        created() {
            this.params.companyId = this.companyId
            this.params.currRouteId = this.$route.query.currRouteId as string
            this.params.orderId = this.$route.query.orderId as string
            this.params.isReturn = this.$route.query.isReturn === '1'
            this.getNodeList()
        }

        getNodeList() {
             getOperateLog(this.params).then((res) => {
                this.logList = res.data.nodeRecord || []
             })
        }
    }
